// Generated by CoffeeScript 2.7.0
var CurrentUser, UserAttributes;

import CurrentAttributesFactory from './factory.js';

UserAttributes = ['id', 'name', 'nickname', 'mode', 'from_wechat', 'tag_ids'];

export default CurrentUser = class CurrentUser extends CurrentAttributesFactory.fabricate(...UserAttributes) {
  _valueObject() {
    return _global.user;
  }

};
